export const Noir = {
  badge: {
    colorScheme: {
      light: {
        root: {
          primary: {
            background: '{slate.950}',
            color: '#ffffff',
          },
        },
      },
    },
  },
  button: {
    colorScheme: {
      light: {
        root: {
          primary: {
            background: '{slate.950}',
            hoverBackground: '{slate.800}',
            activeBackground: '{slate.700}',
            borderColor: '{slate.950}',
            hoverBorderColor: '{slate.800}',
            activeBorderColor: '{slate.700}',
            color: '#ffffff',
            hoverColor: '#ffffff',
            activeColor: '#ffffff',
            focusRing: {
              color: '{slate.950}',
              shadow: 'none',
            },
          },
          secondary: {
            background: '{slate.100}',
            hoverBackground: '{slate.200}',
            activeBackground: '{slate.300}',
            borderColor: '{slate.100}',
            hoverBorderColor: '{slate.200}',
            activeBorderColor: '{slate.300}',
            color: '{slate.600}',
            hoverColor: '{slate.700}',
            activeColor: '{slate.800}',
            focusRing: {
              color: '{slate.600}',
              shadow: 'none',
            },
          },
        },
        outlined: {
          primary: {
            hoverBackground: '{slate.50}',
            activeBackground: '{slate.100}',
            borderColor: '{slate.200}',
            color: '{slate.950}',
          },
          secondary: {
            hoverBackground: '{slate.50}',
            activeBackground: '{slate.100}',
            borderColor: '{slate.200}',
            color: '{slate.500}',
          },
          plain: {
            hoverBackground: '{slate.50}',
            activeBackground: '{slate.100}',
            borderColor: '{slate.200}',
            color: '{slate.700}',
          },
        },
        text: {
          primary: {
            hoverBackground: '{slate.50}',
            activeBackground: '{slate.100}',
            borderColor: 'transparent',
            color: '{slate.950}',
          },
        },
      },
    },
  },
  tag: {
    colorScheme: {
      light: {
        root: {
          primary: {
            background: '{slate.200}',
            color: '{slate.950}',
          },
          secondary: {
            background: '{slate.200}',
            color: '{slate.950}',
          },
          fontWeight: '600',
        },
      },
    },
  },
};
